import React, { useState, useEffect, SetStateAction } from 'react'
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale/ko'
import { Box, Typography } from '@mui/material';
import Icon_Calender from '@mui/icons-material/CalendarTodayOutlined';
import { format, parse } from 'date-fns';


//DateRangePicker
//두개의 박스를 가진 DatePicker 컴포넌트
//둘 사이의 날짜를 전역저장소로 저장해 리렌더링 최소화
//같은 박스가 두 개이므로 하나의 스타일을 조정했을 시, 다른 것도 같이 조정할 것 권장

//작동에는 문제가 없으나 포커스 에러로그가 출력되는 현상이 있음 -> 수정필요함

interface Props{
  textAlign? : string
  start_date? : string | null
  end_date? : string | null
  setstart_date? : React.Dispatch<SetStateAction<any>>
  setend_date? : React.Dispatch<SetStateAction<any>>
}

// 
const safeToDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  if (typeof value === 'string') {
    return parse(value, 'yyyy-MM-dd', new Date()); // ✅ 핵심
  }
  return value;
};

const DateRangePickerAddEtc = ({textAlign, start_date, end_date ,setstart_date, setend_date}:Props) => {
  // const start_date = ModalAdSheduleAddStore((state)=>state.recruitestartdate)
  // const end_date = ModalAdSheduleAddStore((state)=>state.recruiteenddate)
  const [startDate, setStartDate] = useState<Date | null>(safeToDate(start_date));
  const [endDate, setEndDate] = useState<Date | null>(safeToDate(end_date));
  const [openStart,setOpenStart] = useState(false)
  const [openEnd,setOpenEnd] = useState(false)
  // const setField = ModalAdSheduleAddStore((state)=>state.setField)

  useEffect(() => {
    setStartDate(safeToDate(start_date));
    setEndDate(safeToDate(end_date));
  }, [start_date, end_date]);

  useEffect(() => {
    return(()=>{
      setend_date?.(null)
    })
  }, []);


  const handleStart = (newValue: Date | null) => {
    setStartDate(newValue);
    if (newValue) {
      setstart_date?.(format(newValue, 'yyyy-MM-dd'))
    }
    if (endDate && newValue && endDate < newValue) {
      setend_date?.(newValue);
    }
  };

  const handleEnd = (newValue: Date | null) => {
    setEndDate(newValue)

    if (newValue) {
      setend_date?.(format(newValue, 'yyyy-MM-dd'))
    }

  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
      <Box display="flex" alignItems="center" gap="5px" width="100%" height="100%">
        <DatePicker
          open={openStart}
          onOpen={()=>setOpenStart(true)}
          onClose={()=>setOpenStart(false)}
          value={startDate}
          onChange={handleStart}
          maxDate={endDate ?? undefined}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              //박스크기 스타일조정
              placeholder: '전체 기간',
              sx: {
                height:'100%',
                width:'100%',
                backgroundColor:'white',
                '& .MuiInputBase-root': {
                  height: '100%',
                },
                '& input': {
                  fontSize: '14px',
                  color: '#D1D1D1',
                  textAlign: textAlign || 'left',
                },
              },
              //내부 이미지 조정
              InputProps: {
                endAdornment: (
                  <Icon_Calender sx={{color:'#D1D1D1', width:'24px', height:'24px'}}/>
                ),
                onClick:()=>setOpenStart(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
        <Typography>~</Typography>
        <DatePicker
          open={openEnd}
          onOpen={()=>setOpenEnd(true)}
          onClose={()=>setOpenEnd(false)}
          value={endDate}
          onChange={handleEnd}
          minDate={startDate ?? undefined}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              placeholder: '전체 기간',
              sx: {
                height:'100%',
                width:'100%',
                backgroundColor:'white',
                '& .MuiInputBase-root': {
                  height: '100%',
                },
                '& input': {
                  fontSize: '14px',
                  color: '#D1D1D1',
                  textAlign: textAlign || 'left',
                },
              },
              InputProps: {
                endAdornment: (
                  <Icon_Calender sx={{color:'#D1D1D1', width:'24px', height:'24px'}}/>
                ),
                onClick:()=>setOpenEnd(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DateRangePickerAddEtc